import React from "react"
import { Spinner } from 'react-bootstrap'

const Loader = () => {

  return (
    <div className="spinner-wrapper">
        <div className="spinner">
            <Spinner animation='grow' size="xl" className="spin" />
        </div>
    </div> )

}

export default Loader;
